import { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Page, Msg, LoadMore, Toast, Panel } from 'react-weui';
import { ActionContext } from 'actions/context';
import { withStyles } from '@material-ui/core/styles';
import { formatDate, formatNumber } from '../lib/formatter.ts';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import Http from 'services/http2';
import Modal from 'components/modal';
import ModalService from 'services/modal';
import CompanyService from 'services/company2';
import EnumService from 'services/enum2';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Util from 'lib/util.js';
import { useForm, Controller } from 'react-hook-form';
import '../mall.css';

let checkedObj = {}; //已勾选项次
let orderConfirmInfo = {}; //订单确认信息
let formTypeList = [];
const styles = theme => ({
  paper: {
    margin: '10px',
    width: '90vw'
  }
});
function MallProdList(props) {
  const Config = {
    purchase: {
      apiPath: '/innerMall/list',
      enumMainKey: '',
      companyNameKey: 'companyName',
      orderProperty: 'id',
      detailLink: '/mp/purchase/mall/product',
      searchBarPlaceholder: '商品信息',
      tabs: ['全部'],
      // countApi: '',
      // arrEnumField: [
      //   {
      //     mainKey: 'B02_Introduce_Status',
      //     subKey: 'status',
      //     value: 'statusName'
      //   }
      // ],
      // countTransform: (data, self) => {
      //   let { 0: a } = data;
      //   setCount([undefined, a]);
      // },
      tabConfig: [
        undefined //全部
      ]
    }
  };

  const arrCategory = [
    { key: 'platforms', value: '来源', param: 'platformCode' },
    { key: 'categorys', value: '类别', param: 'mroCategoryCode' },
    { key: 'brands', value: '品牌', param: 'mroBrandCodeList' }
  ];
  const { state, dispatch } = useContext(ActionContext);
  const [redirect, setRedirect] = useState(null);
  const [platformCode, setPlatformCode] = useState(null);
  const [listType, setListType] = useState(1); //列表类型，1列表，2网格
  const [filterStatus, setFilterStatus] = useState(false);
  const [oCategoryBrand, setCategoryBrand] = useState({});
  const [platformList, setPlatformList] = useState([]);
  const [currCategory, setCurrCategory] = useState('platforms');
  let [selectedList, setSelectedList] = useState([]); //已选条件
  const [mroParams, setMroParams] = useState({});
  const [checkedList, setCheckedList] = useState([]); //已勾选项次
  const [showPurchaseQtyDialog, setPurchaseQtyDialog] = useState(false);
  const [showConfirmDialog, setConfirmDialog] = useState(false);
  const [purchaseQtyData, setPurchaseQtyData] = useState({});
  const [qtyData, setQtyData] = useState({});
  const [receivePlaceList, setReceivePlaceList] = useState([]);
  const [purchaseTypeList, setPurchaseTypeList] = useState([]);
  const [paramData, setParamData] = useState({});
  const [filterFormTypeList, setFilterFormTypeList] = useState([]);
  const [isOpenOrg, setIsOpenOrg] = useState(false);
  const [purchaseOrgList, setPurchaseOrgList] = useState([]);
  const config = Config[props.type];
  const {
    companyCode,
    companyName,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    setShowLoading,
    list,
    count,
    setList,
    setListField,
    setTotalField,
    setCount,
    setSearchKey,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  const { control, register, setValue, handleSubmit } = useForm();

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
    // 获取采购组织列表
    async function getPurchaseOrgList() {
      if (!companyCode) {
        return;
      }
      //是否开启采购组织
      let res = await CompanyService.checkOpenOrg(companyCode);

      if (res) {
        let arr = await CompanyService.getPurchaseOrgList(companyCode);
        setPurchaseOrgList(arr);
        setIsOpenOrg(true);
      }
    }
    if (companyCode) {
      //采购组织
      getPurchaseOrgList();
      // 收货地址
      CompanyService.getDeliveryAddressList(companyCode).then(arr => {
        setReceivePlaceList(arr);
      });
      // 采购类型
      EnumService.getList('B02_Purchase_Type').then(data => {
        if (!Util.isEmpty(data)) {
          let arr = data.map(item => {
            return { id: item.subKey, text: item.subValue };
          });
          setPurchaseTypeList(arr);
        }
      });
      //单别
      CompanyService.getFormTypeData(companyCode).then(res => {
        if (!Util.isEmpty(res)) {
          formTypeList = res;
        }
      });
    }
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, mroParams, self]);

  //根据依赖多次执行
  useEffect(() => {
    function getCategoryBrand() {
      if (!companyCode) {
        return;
      }
      let postbody = {
        companyCode: companyCode,
        searchKey: searchKey,
        platformCode: platformCode,
        apiPath: '/innerMall/category/brand'
      };
      Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success && response.data) {
          let data = response.data;
          if (!platformCode && data.platforms.length) {
            setPlatformList(data.platforms);
          }
          setCategoryBrand(data);
        }
      });
    }
    getCategoryBrand();
  }, [searchKey, companyCode, platformCode]);

  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        statusList: config.tabConfig[currentTab],
        ...mroParams
      };
    }
  };

  self.listTransform = async function (arr) {
    ModalService.showLoading(dispatch);
    if (Array.isArray(arr)) {
      arr.forEach(item => {
        item.productClassName = '';

        if (item.productStatus === 0) {
          item.productClassName = 'lose-item'; //已失效
        } else if (item.status === 2) {
          item.productClassName = 'outof-item'; //已停用
        }
      });
    }
    ModalService.hideLoading(dispatch);
  };

  function handleFilter(item) {
    item.checked = !item.checked;
    // 来源
    if (currCategory === 'platforms') {
      if (item.checked) {
        clearAllSelected(currCategory);
        setPlatformCode(item.value);
        platformList.forEach(row => {
          row.checked = row.value === item.value;
        });
      } else {
        clearAllSelected();
      }
      //同步
      oCategoryBrand['platforms'].some(row => {
        if (row.value === item.value) {
          row.checked = item.checked;
        }
        return row.value === item.value;
      });
    } else if (currCategory === 'categorys') {
      // 类别
      if (item.checked) {
        oCategoryBrand[currCategory].forEach(row => {
          row.checked = row.value === item.value;
        });
      }
    } else {
      // 品牌
    }
    getSelectedList();
  }

  //获取已选条件
  function getSelectedList() {
    let arr = [];
    platformList.some(row => {
      if (row.checked) {
        arr.push({
          key: 'platforms',
          value: row.value,
          name: row.name
        });
      }
      return row.checked;
    });
    for (let key in oCategoryBrand) {
      if (key !== 'platforms' && Array.isArray(oCategoryBrand[key])) {
        oCategoryBrand[key].forEach(row => {
          if (row.checked) {
            arr.push({
              key: key,
              value: row.value,
              name: row.name
            });
          }
        });
      }
    }
    setSelectedList(arr);
  }

  //删除已选条件
  function delSelectedItem(item, isReset) {
    item.checked = false;
    if (item.key === 'platforms') {
      clearAllSelected();
    } else {
      for (let key in oCategoryBrand) {
        if (key === item.key && Array.isArray(oCategoryBrand[key])) {
          oCategoryBrand[key].some(row => {
            if (row.value === item.value) {
              row.checked = false;
            }
            return row.value === item.value;
          });
        }
      }
      getSelectedList();
    }
    if (isReset) {
      setTimeout(() => {
        filterConfirm();
      }, 100);
    }
  }

  //清空已选
  function clearAllSelected(param) {
    platformList.forEach(row => (row.checked = false));
    for (let key in oCategoryBrand) {
      if (Array.isArray(oCategoryBrand[key])) {
        oCategoryBrand[key].forEach(row => (row.checked = false));
      }
    }
    setSelectedList([]);
    selectedList = [];
    if (!param) {
      setPlatformCode('');
    }
  }

  //已选条件确认
  function filterConfirm() {
    let opts = {};
    if (Array.isArray(selectedList)) {
      arrCategory.forEach(obj => {
        if (obj.key === 'brands') {
          opts[obj.param] = selectedList
            .filter(item => item.checked !== false && item.key === obj.key)
            .map(item => item.value);
        } else {
          selectedList.some(item => {
            if (item.checked !== false && item.key === obj.key) {
              opts[obj.param] = item.value;
            }
            return item.key === obj.key;
          });
        }
      });
    }
    handleReset();
    setMroParams(opts);
    setFilterStatus(false);
  }

  function handleChecked(item) {
    let key = item.mroSkuNo + item.inductXkNo + item.mroProductCode;
    item.checked = !item.checked;
    if (item.checked) {
      checkedObj[key] = { ...item };
    } else {
      delete checkedObj[key];
    }
    let arr = Object.values(checkedObj);
    setCheckedList(arr);
  }

  //生成引入单
  function createIntroduceOrder() {
    let checkeds = list.filter(item => item.checked);
    if (checkeds.some(item => item.productStatus !== 0)) {
      ModalService.showError('所选项次不能包含有效商品', dispatch);
      return;
    }
    let ok = () => {
      let arr = checkeds.map(item => {
        return {
          inductXkNo: item.inductXkNo,
          lineNo: item.lineNo,
          detailLineNo: item.detailLineNo,
          companyCode: item.companyCode
        };
      });
      let postbody = {
        companyCode: companyCode,
        companyName: companyName,
        list: arr,
        apiPath: '/innerMall/create/introduce/order'
      };
      ModalService.showLoading(dispatch);
      Http.post('/api/cloudCenter', postbody).then(response => {
        ModalService.hideLoading(dispatch);
        if (response.success) {
          ModalService.showTip('操作成功', dispatch);
          setTimeout(() => {
            setRedirect(
              '/mp/purchase/mall/introduce-detail/' +
                companyCode +
                '/' +
                response.data
            );
          }, 1500);
        } else {
          ModalService.showError(response.errorMsg, dispatch);
        }
      });
    };
    ModalService.showConfirm('确认生成引入单？', ok, dispatch);
  }

  //获取编辑采购数量的列表
  function getEditPurchaseQtyList(arr) {
    let checkeds = !Util.isEmpty(arr) ? arr : checkedList;

    checkeds = checkeds.map(item => {
      let qty = item.qty || (item.minOrderQty ? Number(item.minOrderQty) : 0);
      return {
        companyCode: item.companyCode,
        inductXkNo: item.inductXkNo,
        lineNo: item.lineNo,
        detailLineNo: item.detailLineNo,
        mroSkuNo: item.mroSkuNo,
        mroProductCode: item.mroProductCode,
        qty: qty,
        sourceReqXkNo: item.sourceReqXkNo,
        sourceReqLineNo: item.sourceReqLineNo,
        sourceReqInnerNo: item.sourceReqInnerNo,
        sourceReqQty: item.sourceReqQty,
        productCode: item.productCode,
        productName: item.productName,
        productScale: item.productScale,
        taxCode: item.taxCode,
        taxRate: item.taxRate,
        taxName: item.taxName,
        newFlag: item.newFlag,
        isPricing: item.isPricing
      };
    });

    if (checkeds.length === 0) {
      ModalService.showTip('至少选择一项', dispatch);
      return;
    }
    let postbody = {
      companyCode: companyCode,
      list: checkeds,
      apiPath: '/innerMall/purchase/detail'
    };
    ModalService.showLoading(dispatch);
    Http.post('/api/cloudCenter', postbody).then(response => {
      ModalService.hideLoading(dispatch);
      if (response.success) {
        setPurchaseQtyDialog(true);
        let data = response.data;
        if (data) {
          setPurchaseQtyData(data);
        }
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  //文本|数字字段改变
  function handleInputChange(e, item) {
    let obj = {},
      name = e.target.name,
      value = e.target.value;
    let key = item.mroSkuNo + item.inductXkNo + item.mroProductCode;
    if (name === 'qty') {
      value = Util.qtyChange(value);
    }
    value = Number(value);
    obj[name] = value;
    item[name] = value;
    setQtyData(obj);
    if (value === 0) {
      return;
    }
    if (value < item.minOrderQty) {
      ModalService.showError('采购数量不得低于最小起订量', dispatch);
      return;
    }
    let arr = checkedList.map(row => {
      let o = { ...row };
      let uid = o.mroSkuNo + o.inductXkNo + o.mroProductCode;
      if (key === uid) {
        o.qty = value;
      }
      return o;
    });
    setCheckedList(arr);
    getEditPurchaseQtyList(arr);
  }

  function handleItemDel(item) {
    let key = item.mroSkuNo + item.inductXkNo + item.mroProductCode;
    delete checkedObj[key];
    let arr = Object.values(checkedObj);
    if (arr.length === 0) {
      close();
      return;
    }
    setCheckedList(arr);
    getEditPurchaseQtyList(arr);
  }

  // 关闭
  function close() {
    setPurchaseQtyDialog(false);
    setCheckedList([]);
    checkedObj = {};
    list.forEach(item => (item.checked = false));
    setList(list);
  }

  //生成采购订单
  function poGenerate() {
    setConfirmDialog(true);
  }

  function closeConfirmDialog() {
    setConfirmDialog(false);
  }

  //生成采购订单-订单信息确认
  function confirm(formData) {
    let info = {};
    let arr = [];
    purchaseQtyData.group.forEach(group => {
      if (Array.isArray(group.list)) {
        group.list.forEach(row => {
          arr.push({
            inductXkNo: row.inductXkNo,
            lineNo: row.lineNo,
            detailLineNo: row.detailLineNo,
            qty: Number(row.qty),
            companyCode: row.companyCode,
            sourceReqXkNo: row.sourceReqXkNo,
            sourceReqLineNo: row.sourceReqLineNo,
            sourceReqInnerNo: row.sourceReqInnerNo,
            isPricing: row.isPricing
          });
        });
      }
    });
    let postbody = {
      companyCode: companyCode,
      companyName: companyName,
      list: arr,
      ...info,
      apiPath: '/innerMall/create/purchase/order'
    };
    ModalService.showLoading(dispatch);
    Http.post('/api/cloudCenter', postbody).then(response => {
      ModalService.hideLoading(dispatch);
      if (response.success) {
        ModalService.showTip('操作成功', dispatch);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  function handleSelectChange(e) {
    let value = e.target.value,
      name = e.target.name;
    if (name === 'purchaseTypeCode') {
      setParamData({ purchaseTypeCode: value, formTypeCode: '' });
      let arr = formTypeList
        .filter(item => item.purchaseType === value)
        .map(item => {
          return {
            id: item.typeCode,
            text: item.typeName.trim()
          };
        });
      setFilterFormTypeList(arr);
    }
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <span>
      <Page
        transition={false}
        ptr={false}
        onLoadMore={(resolveLoading, finish) => {
          self.pageResolveLoading = resolveLoading;
          if (list.length >= total) {
            finish();
          } else {
            self.search();
          }
        }}
        className="v2"
      >
        <TopNav
          inited={inited}
          onSubmit={handleChange}
          onCancel={handleClear}
          onClear={handleClear}
          defaultValue={searchKey}
          placeholder={config.searchBarPlaceholder}
        />
        <Panel>
          {dataError !== null ? (
            <Msg {...dataError} />
          ) : (
            <span>
              <div className="m-tab-flex-wrap">
                <div className="m-tab-container">
                  <ul className="m-flex-box">
                    {config.tabs.map((item, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          handleTab(index);
                        }}
                        className={
                          currentTab === index
                            ? 'm-flex-item curr'
                            : 'm-flex-item'
                        }
                      >
                        <span className="name">{item}</span>
                        {count[index] && (
                          <sup className="u-num">{count[index]}</sup>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="m-side-box">
                  <span className="side-item">
                    {listType === 1 && (
                      <img
                        src="/assets/img/mp/icon-type.svg"
                        alt=""
                        onClick={() => {
                          setListType(2);
                        }}
                      />
                    )}
                    {listType === 2 && (
                      <img
                        src="/assets/img/mp/icon-type-list.svg"
                        alt=""
                        onClick={() => {
                          setListType(1);
                        }}
                      />
                    )}
                  </span>
                  <span
                    className={`side-item ${filterStatus ? 'curr' : ''}`}
                    onClick={() => {
                      setFilterStatus(!filterStatus);
                    }}
                  >
                    <i className="icon-filter"></i>
                    筛选
                  </span>
                </div>
              </div>
              {/* <div className="m-filter-wrap">
              <div className="m-search-box">
                <input
                  type="search"
                  placeholder="请输入关键词"
                  value={searchKey || ''}
                  onChange={e => {
                    setSearchKey(e.target.value);
                  }}
                  onSubmit={e => {
                    handleChange();
                  }}
                />

                {!searchKey && <i className="icon-search"></i>}
                {searchKey && (
                  <i
                    className="icon-error-fill"
                    onClick={() => {
                      setSearchKey('');
                      handleChange();
                    }}
                  ></i>
                )}
              </div>
              <div className="m-side-box"></div>
            </div> */}
              <div className="list-total">{total}</div>
              <div className="m-details-item">
                {/* 已选条件 */}
                {Array.isArray(selectedList) &&
                  selectedList.length > 0 &&
                  !filterStatus && (
                    <div className="filter-selected-box">
                      {arrCategory.map(
                        (category, idx) =>
                          selectedList.filter(row => row.key === category.key)
                            .length > 0 && (
                            <div key={idx} className="filter-selected-item">
                              <span className="label">{category.value}</span>
                              <ul className="filter-selected-list clearfix">
                                {selectedList
                                  .filter(row => row.key === category.key)
                                  .map((row, index) => (
                                    <li
                                      key={index}
                                      onClick={() => {
                                        delSelectedItem(row, true);
                                      }}
                                    >
                                      {row.name}
                                      <i className="icon-close"></i>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          )
                      )}
                    </div>
                  )}
                <div
                  className={`details-item-content card-list card-type-${listType}`}
                >
                  {updateTs > 0 &&
                    list.map((item, index) => (
                      <div
                        className={`card-item ${item.productClassName}`}
                        key={index}
                      >
                        {/* <Link
                        to={`${config.detailLink}/${item.mroSkuNo}/${item.vendorCode}/${item.mroProductCode}`}
                        className="content-line line-list-item"
                      > */}
                        <div className="content-line line-list-item">
                          <div className="card-item-image">
                            {listType === 1 && (
                              <img src={item.imageUrl} alt="" />
                            )}
                            {listType === 2 && (
                              <div
                                className="bg-image"
                                style={{
                                  backgroundImage: 'url(' + item.imageUrl + ')'
                                }}
                              ></div>
                            )}
                          </div>
                          <div className="card-item-content">
                            <p className="line-clamp-box product-name">
                              {item.mroProductName}
                            </p>
                            <p>
                              <span className="label">产品型号：</span>
                              <span className="content">
                                {item.mroProductModelNo}
                              </span>
                            </p>
                            <p>
                              <span className="label">内部料号：</span>
                              <span className="content">
                                {item.productCode}
                              </span>
                            </p>
                            <p>
                              <span className="label">最小起订量：</span>
                              <span className="content">
                                {item.minOrderQty}
                                {item.minOrderQty && item.unitName && (
                                  <span>{item.unitName}起</span>
                                )}
                              </span>
                            </p>
                            <p className="product-price">
                              <span className="discount-price">
                                &yen;{item.discountPrice || '--'}
                              </span>
                              <del className="ori-price">
                                &yen;{item.oriPrice}
                              </del>
                            </p>
                            <div className="card-item-footer">
                              {item.isPricing !== 1 && (
                                <span className="sign sign-red">
                                  {item.platformName}
                                </span>
                              )}
                              {item.isPricing === 1 && (
                                <span className="sign sign-red">核价商品</span>
                              )}
                              {item.orderStockType === 1 && (
                                <span className="sign">生产</span>
                              )}
                              {item.orderStockType === 2 && (
                                <span className="sign">现货</span>
                              )}
                              {item.deliveryTime > 1 && (
                                <span className="sign">
                                  {item.deliveryTime}个工作日
                                </span>
                              )}
                              {item.deliveryTime === 1 && (
                                <span className="sign">次日</span>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* </Link> */}
                        {!(item.status === 2 && item.productStatus !== 0) && (
                          <span
                            className={`custom-label-box ${
                              item.checked ? 'checked' : ''
                            }`}
                          >
                            <span onClick={() => handleChecked(item)}>
                              <i className="icon-radio"></i>
                              <i className="icon-confirm-fill"></i>
                            </span>
                          </span>
                        )}
                      </div>
                    ))}
                  {!showLoading && list.length === 0 && (
                    <LoadMore showLine> 暂无数据</LoadMore>
                  )}
                </div>
              </div>
              {/* 过滤条件开窗 */}
              {filterStatus === true && (
                <div className="filter-container-pop">
                  <div className="filter-container-inner">
                    {Array.isArray(selectedList) && selectedList.length > 0 && (
                      <div className="filter-selected">
                        <h4>已选条件</h4>
                        <ul className="filter-selected-list clearfix">
                          {selectedList.map((row, index) => (
                            <li
                              key={index}
                              onClick={() => {
                                delSelectedItem(row);
                              }}
                            >
                              {row.name}
                              <i className="icon-close"></i>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    <div className="filter-condition">
                      <div className="filter-side">
                        {arrCategory.map((item, index) => (
                          <div
                            className={`label-item ${
                              item.key === currCategory ? 'curr' : ''
                            }`}
                            key={index}
                            onClick={() => {
                              setCurrCategory(item.key);
                            }}
                          >
                            {item.value}
                          </div>
                        ))}
                      </div>
                      <div className="filter-main">
                        <div className="content-list clearfix">
                          {/* 来源 */}
                          {currCategory === 'platforms' &&
                            platformList.map((item, index) => (
                              <div
                                className={`content-item ${
                                  item.checked ? 'curr' : ''
                                }`}
                                key={index}
                                onClick={() => {
                                  handleFilter(item);
                                }}
                              >
                                <span className="clamp">{item.name}</span>
                              </div>
                            ))}
                          {/* 类别、品牌 */}
                          {['categorys', 'brands'].includes(currCategory) &&
                            oCategoryBrand[currCategory] &&
                            oCategoryBrand[currCategory].map((item, index) => (
                              <div
                                className={`content-item ${
                                  item.checked ? 'curr' : ''
                                }`}
                                key={index}
                                onClick={() => {
                                  handleFilter(item);
                                }}
                              >
                                <span className="clamp">{item.name}</span>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 按钮 */}
                  <div className="filter-main-footer">
                    <div className="footer-inner">
                      <span
                        className="u-btn u-btn_line"
                        onClick={() => {
                          clearAllSelected();
                        }}
                      >
                        重置
                      </span>
                      <span
                        className="u-btn u-btn_primary"
                        onClick={() => {
                          filterConfirm();
                        }}
                      >
                        确定
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {/* 底部按钮 */}
              {checkedList.length > 0 && (
                <div className="batch-container">
                  <div className="batch-item">
                    <span
                      onClick={() => {
                        getEditPurchaseQtyList();
                      }}
                    >
                      <i className="icon-edit-new"></i>编辑采购数量
                    </span>
                  </div>
                  <div className="batch-item">
                    <span
                      onClick={() => {
                        createIntroduceOrder();
                      }}
                    >
                      <i className="icon-add-new"></i>生成引入单
                    </span>
                  </div>
                </div>
              )}
            </span>
          )}
        </Panel>

        <Dialog
          classes={{ paper: props.classes.paper }}
          open={showPurchaseQtyDialog}
          onClose={() => close()}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle className="dialog-purchase-qty-title">
            编辑采购数量
          </DialogTitle>
          <DialogContent className="dialog-purchase-qty-body">
            {Array.isArray(purchaseQtyData.group) && (
              <div className="purchase-qty-group">
                {purchaseQtyData.group.map((group, idx) => (
                  <div key={idx} className="purchase-qty-item">
                    <div className="purchase-qty-item-header">
                      {group.vendorName}（{group.productNum}件商品，总价：
                      <span className="red">&yen;{group.totalAmount}</span>
                      ，运费：&yen;
                      {group.freightAmount}）
                    </div>
                    <div className="purchase-qty-item-body">
                      {group.list.map((item, index) => (
                        <div key={index} className="purchase-qty-item-sub">
                          <div className="sub-col col2">
                            <img src={item.imageUrl} alt="" />
                          </div>
                          <div className="sub-col col3">
                            <p>
                              {item.productName} {item.productCode}
                            </p>
                            <p className="amount">
                              <span>
                                单价：
                                {formatNumber(
                                  item.taxPrice,
                                  item.Price_Decimal_Place
                                )}
                              </span>
                              <span>
                                金额：
                                {formatNumber(
                                  item.taxAmount,
                                  item.Amount_Decimal_Place
                                )}
                              </span>
                            </p>
                            <p className="qty">
                              <span>采购数量：</span>
                              <input
                                type="text"
                                name="qty"
                                value={item.qty}
                                onChange={e => handleInputChange(e, item)}
                              />
                            </p>
                          </div>
                          <div className="sub-col">
                            <p>
                              <span
                                className="link"
                                onClick={() => {
                                  handleItemDel(item);
                                }}
                              >
                                删除
                              </span>
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
                <p className="total">
                  已选择 {purchaseQtyData.productNum} 件商品，总价：
                  <span className="red">
                    &yen;
                    {purchaseQtyData.totalAmount}
                  </span>
                  ，运费：&yen;
                  {purchaseQtyData.freightAmount}
                </p>
              </div>
            )}
          </DialogContent>
          <DialogActions className="dialog-sticky-actions">
            <Button onClick={close}>取消</Button>
            <Button
              variant="contained"
              color="primary"
              className="mui-btn-primary"
              onClick={() => poGenerate()}
            >
              生成采购订单
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          classes={{ paper: props.classes.paper }}
          open={showConfirmDialog}
          onClose={() => closeConfirmDialog()}
        >
          <form onSubmit={handleSubmit(confirm)}>
            <DialogTitle className="dialog-confirm-title">
              订单信息确认
            </DialogTitle>
            <DialogContent className="mui-dialog-content dialog-confirm-body">
              {isOpenOrg && (
                <div className="form-item">
                  <p className="form-item-name">采购组织</p>
                  <Controller
                    name="erpOrgCode"
                    control={control}
                    defaultValue={''}
                    render={({ field }) => (
                      <select {...field}>
                        <option key="-1" value="">
                          请选择
                        </option>
                        {purchaseOrgList.map((row, j) => (
                          <option key={j} value={row.id}>
                            {row.text}
                          </option>
                        ))}
                      </select>
                    )}
                  />
                </div>
              )}
              <div className="form-item">
                <p className="form-item-name">收货地址</p>
                <Controller
                  name="addressCode"
                  control={control}
                  defaultValue={''}
                  render={({ field }) => (
                    <select {...field}>
                      <option key="-1" value="">
                        请选择
                      </option>
                      {receivePlaceList.map((row, j) => (
                        <option key={j} value={row.id}>
                          {row.text}
                        </option>
                      ))}
                    </select>
                  )}
                />
              </div>
              <div className="form-item">
                <p className="form-item-name">采购类型</p>
                <Controller
                  name="purchaseTypeCode"
                  control={control}
                  defaultValue={''}
                  render={({ field }) => (
                    <select
                      name="purchaseTypeCode"
                      onChange={e => handleSelectChange(e)}
                    >
                      {purchaseTypeList.map((row, j) => (
                        <option key={j} value={row.id}>
                          {row.text}
                        </option>
                      ))}
                    </select>
                  )}
                />
              </div>
              <div className="form-item">
                <p className="form-item-name">采购单别</p>
                <Controller
                  name="formTypeCode"
                  control={control}
                  defaultValue={''}
                  render={({ field }) => (
                    <select {...field}>
                      <option key="-1" value="">
                        请选择
                      </option>
                      {filterFormTypeList.map((row, j) => (
                        <option key={j} value={row.id}>
                          {row.text}
                        </option>
                      ))}
                    </select>
                  )}
                />
              </div>
              {/* <div className="form-item">
                <p className="form-item-name">交易条件</p>
              </div>
              <div className="form-item">
                <p className="form-item-name">付款条件</p>
              </div>
              <div className="form-item">
                <p className="form-item-name">成本中心</p>
              </div>
              <div className="form-item">
                <p className="form-item-name">总账科目</p>
              </div> */}
              <div className="form-item">
                <p className="form-item-name">备注</p>
                <input
                  type="text"
                  {...register('remark', {
                    onChange: e => {}
                  })}
                />
              </div>
            </DialogContent>
            <DialogActions className="dialog-sticky-actions">
              <Button onClick={closeConfirmDialog}>取消</Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className="mui-btn-primary"
              >
                确定
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        <Toast icon="loading" show={showLoading}>
          数据加载中...
        </Toast>
      </Page>
      <Modal></Modal>
    </span>
  );
}

MallProdList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(withStyles(styles)(MallProdList));
